import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie } from "lucide-react";

const KEY = "av_cookie_consent";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);
  const [prefs, setPrefs] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    if (!localStorage.getItem(KEY)) setVisible(true);
    const openPrefs = () => { setPrefs(true); setVisible(true); };
    window.addEventListener("open-cookie-preferences", openPrefs);
    return () => window.removeEventListener("open-cookie-preferences", openPrefs);
  }, []);

  const decide = (value) => {
    localStorage.setItem(KEY, JSON.stringify({ value, ts: Date.now() }));
    window.dispatchEvent(new Event("cookie-consent-changed"));
    setVisible(false);
    setPrefs(false);
  };

  return (
    <AnimatePresence>
      {visible && !pathname.startsWith("/admin") && (
        <motion.div
          data-testid="cookie-banner"
          className="fixed z-50 bottom-4 left-4 right-4 sm:left-6 sm:right-auto sm:max-w-md"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 30 }}
          transition={{ duration: 0.4, ease: [0.19, 1, 0.22, 1] }}
        >
          <div className="rounded-2xl bg-av-black/95 backdrop-blur-xl border border-white/15 p-6 shadow-2xl">
            <div className="flex items-center gap-3 mb-3">
              <Cookie size={20} className="text-av-bright" />
              <h2 className="font-display text-xl">Rispettiamo la tua privacy</h2>
            </div>
            <p className="text-sm text-av-gray leading-relaxed">
              Utilizziamo solo cookie tecnici necessari al funzionamento del sito. Non attiviamo cookie di
              marketing o strumenti di tracciamento senza il tuo consenso. Consulta la{" "}
              <Link to="/cookie-policy" className="text-av-lime underline">Cookie Policy</Link>.
            </p>
            <div className="mt-5 flex flex-wrap gap-3">
              <button
                data-testid="cookie-accept"
                onClick={() => decide("all")}
                className="rounded-full bg-av-bright text-av-black px-5 py-2.5 text-sm font-semibold hover:bg-av-lime transition-colors"
              >
                Accetta tutti
              </button>
              <button
                data-testid="cookie-reject"
                onClick={() => decide("necessary")}
                className="rounded-full border border-white/25 text-av-white px-5 py-2.5 text-sm font-semibold hover:border-av-lime hover:text-av-lime transition-colors"
              >
                Solo necessari
              </button>
            </div>
            {prefs && (
              <p className="mt-4 text-xs text-av-gray/70">
                Preferenze attuali: attivi solo i cookie tecnici necessari.
              </p>
            )}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
